import WebhookCardapioContent from "./components/WebhookCardapioContent";
import { WebhookCardapioProvider } from "./context/WebhookCardapioContext";

const WebhookCardapio = () => (
  <WebhookCardapioProvider>
    <WebhookCardapioContent />
  </WebhookCardapioProvider>
);

export default WebhookCardapio;
